import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "home" }

import { defineAsyncComponent } from "vue";
import HelloWorld from "@/components/HelloWorld.vue";
import AboutView from "@/views/AboutView.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const info = defineAsyncComponent({
  loader: () => import("@/components/HelloWorld.vue"),
  loadingComponent: AboutView,
  delay: 200,
  errorComponent: HelloWorld,
  timeout: 500,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      alt: "Vue logo",
      src: _imports_0
    }, null, -1)),
    _createVNode(_unref(info), { msg: "Welcome to Your Vue.js + TypeScript App" })
  ]))
}
}

})